import { Currency } from '@/store/reducers/payout';

const SYMBOL: Record<Currency, string> = { USD: '$', UAH: '₴' };

// Amounts come back from the API as plain numbers, already rounded to cents by
// the database's numeric(12,2). Dollars unless said otherwise -- only an expense
// can be in hryvnia. Whole amounts are the common case and read better without
// trailing zeros.
export const formatMoney = (amount: number, currency: Currency = 'USD'): string => {
  const rounded = Math.round(amount * 100) / 100;
  const body = Number.isInteger(rounded)
    ? rounded.toLocaleString('en-US')
    : rounded.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  return `${SYMBOL[currency] || '$'}${body}`;
};

// Hryvnia is never converted, only shown beside the dollar figure: "$500 + ₴300".
// A dollar part of zero is dropped when there is hryvnia to show instead.
export const formatMoneyWithUah = (usd: number, uah?: number): string => {
  if (!uah) return formatMoney(usd);
  if (!usd) return formatMoney(uah, 'UAH');

  return `${formatMoney(usd)} + ${formatMoney(uah, 'UAH')}`;
};

export const formatSigned = (amount: number): string => (
  `${amount >= 0 ? '+' : '-'}${formatMoney(Math.abs(amount))}`
);

export default formatMoney;
